export const StatusEmitterMixin = {
  computed: {
    validated () {
      console.log('OVERRIDE COMPUTED - validated')
    },
    status () {
      return {
        validated: this.validated
      }
    }
  },
  watch: {
    status () {
      this.emitStatus()
    }
  },
  methods: {
    emitStatus () {
      this.$emit('input', this.status)
    }
  },
  created () {
    this.emitStatus()
  }
}
